"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPortalRoot = void 0;

const getPortalRoot = _ref => {
  let {
    rootRef,
    rootId = 'body'
  } = _ref;
  return (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) || (rootId === 'body' ? document.body : document.getElementById(rootId));
};

exports.getPortalRoot = getPortalRoot;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRQb3J0YWxSb290Iiwicm9vdFJlZiIsInJvb3RJZCIsImN1cnJlbnQiLCJkb2N1bWVudCIsImJvZHkiLCJnZXRFbGVtZW50QnlJZCJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BvcnRhbC9Qb3J0YWwudXRpbHMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUG9ydGFsUHJvcHMgfSBmcm9tICd+Y29tcG9uZW50cy9Qb3J0YWwvUG9ydGFsLnR5cGVzJ1xuXG5leHBvcnQgY29uc3QgZ2V0UG9ydGFsUm9vdCA9ICh7IHJvb3RSZWYsIHJvb3RJZCA9ICdib2R5JyB9OiBQb3J0YWxQcm9wcykgPT5cbiAgcm9vdFJlZj8uY3VycmVudCB8fCAocm9vdElkID09PSAnYm9keScgPyBkb2N1bWVudC5ib2R5IDogZG9jdW1lbnQuZ2V0RWxlbWVudEJ5SWQocm9vdElkKSlcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVPLE1BQU1BLGFBQWEsR0FBRztFQUFBLElBQUM7SUFBRUMsT0FBRjtJQUFXQyxNQUFNLEdBQUc7RUFBcEIsQ0FBRDtFQUFBLE9BQzNCLENBQUFELE9BQU8sU0FBUCxJQUFBQSxPQUFPLFdBQVAsWUFBQUEsT0FBTyxDQUFFRSxPQUFULE1BQXFCRCxNQUFNLEtBQUssTUFBWCxHQUFvQkUsUUFBUSxDQUFDQyxJQUE3QixHQUFvQ0QsUUFBUSxDQUFDRSxjQUFULENBQXdCSixNQUF4QixDQUF6RCxDQUQyQjtBQUFBLENBQXRCIn0=